import React, {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilState, useSetRecoilState} from 'recoil';
import {lock, unlock} from 'tua-body-scroll-lock';

import {
  EditableCommunity,
  isOpenTempAlert,
  isOpenTempModal,
  tempAlertType,
} from '@/store';

import FilterModalHeader from '../FilterModal/FilterModalHeader';

interface Props {
  tempItem: TempItem | undefined;
}

export default function TempModal({tempItem}: Props) {
  const navigator = useNavigate();
  const [openTempModal, setOpenTempModal] = useRecoilState(isOpenTempModal);
  const setEditableCommunity = useSetRecoilState(EditableCommunity);
  const setTempAlertType = useSetRecoilState(tempAlertType);
  const setOpenTempAlert = useSetRecoilState(isOpenTempAlert);
  const removeItem = async () => {
    await setTempAlertType('delete');
    setOpenTempAlert(true);
  };
  const loadTempItem = async () => {
    await setEditableCommunity(tempItem?.contents as CommunityContentReq);
    navigator('/community/add');
    setOpenTempModal(false);
  };

  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (openTempModal) {
      lock();
    } else {
      unlock();
    }
  }, [openTempModal]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  const handleClickOutside = (event: any) => {
    if (wrapperRef && !wrapperRef?.current?.contains(event.target)) {
      setOpenTempModal(false);
    } else {
      setOpenTempModal(true);
    }
  };
  return (
    <div
      className="modal-wrapper"
      style={{display: openTempModal ? 'flex' : 'none'}}>
      <div
        ref={wrapperRef}
        className={`modal-contents category ${openTempModal ? 'active' : ''}`}>
        <FilterModalHeader
          txt={'임시저장 게시글'}
          close={() => setOpenTempModal(false)}
          fnTxt="초기화"
        />
        {tempItem && (
          <ul className="temp-modal-body">
            <li className="temp-item">
              <div
                className="contents-info"
                onClick={() => loadTempItem()}
                style={{cursor: 'pointer'}}>
                {tempItem?.contents.images.length > 0 ? (
                  <div
                    className="pic"
                    style={{
                      background: `url(${tempItem.contents.images[0].image}) no-repeat center / cover`,
                    }}></div>
                ) : (
                  <div className="pic"></div>
                )}
                <div className="info">
                  <div className="name">
                    {tempItem ? tempItem.contents.title : '제목없음'}
                  </div>
                  <div className="date">
                    {tempItem?.created
                      ? `${tempItem.created
                          .split('T')[0]
                          .replace('/', '.')} 저장됨`
                      : ''}
                  </div>
                </div>
              </div>
              <div className="trash-icon-wrapper" onClick={() => removeItem()}>
                <span className="icon trash-icon">&nbsp;</span>
              </div>
            </li>
            <li className="sub-message">
              게시글 임시저장은 1개까지 가능합니다.
            </li>
          </ul>
        )}
        {!tempItem && (
          <div className="category-modal-body no-temp">
            <div className="message">임시저장 게시글이 없습니다.</div>
            <div className="sub-message">
              게시글 임시저장은 1개까지 가능합니다.
            </div>
          </div>
        )}
        <div className="filter-modal-footer">
          {/* <button
            className="modal btn black-filled"
            style={{display: tempItem ? 'block' : 'none'}}
            onClick={() => loadTempItem()}>
            선택 완료
          </button> */}
          <button
            className="modal btn empty"
            onClick={() => setOpenTempModal(false)}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
}
